<template>
  <div id="">
    <div class="row datepickerwrap card">
      <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mycols">
          <div class="space-between mb-1">
            <h1></h1>
            <div style="display: flex; line-height: 33px">
              <div class="pinkColor mr-2 px-2">Product Count</div>
              <div class="skyColor mr-2 px-2">Total Product</div>
              <date-range-picker
                v-model="dateRange"
                opens="left"
                :autoApply="true"
                :locale-data="{ format: 'yyyy-mm-dd' }"
                @update="tableDateChange"
                style="border: none"
              >
              </date-range-picker>
            </div>
          </div>
          <div class="">
            <div v-if="!viewKeywordData.length" class="no-data">No Data</div>
            <table class="mt-2" v-if="viewKeywordData.length" id="keywordTracker" style="width: 100%">
              <thead >
                <tr>
                  <th scope="col" v-for="th of tableHeader" :key="th.key" class="p-2">
                    {{ th.label }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr class="tr3row" v-for="(row, i) in viewKeywordData" :key="i">
                  <td v-for="(d, j) in tableHeader" :key="j">
                    <div
                      v-if="row[d.key].length"
                      style="text-transform: capitalize; font-weight: bold"
                    >
                      {{ row[d.key] }}
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <tbody>
                        <tr>
                          <td v-for="iTh of innerTableHeader" :key="iTh.key"></td>
                        </tr>
                        <tr style="width: 100vw">
                          <td
                            v-for="(data, i) of innerTableHeader"
                            :key="i"
                            :class="data.key == 'item_count' ? 'pinkColor' : 'skyColor'"
                            style="padding: 0px 10px; width: 3vw"
                          >
                            <div style="width: 100%">{{ row[d.key][data.key] }}</div>
                          </td>
                        </tr>
                      </tbody>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
export default {
  name: "KeywordTrackerTableData",
  components: { Datepicker },

  data: function () {
    return {
      loader: false,
      dateRange: {
        startDate: "2022-08-01",
        endDate: "2022-08-02",
      },
      tableHeader: [
        { key: "key", label: "Keyword" },
        { key: "sov_page_1", label: "SOV Page- 1" },
        { key: "sov_page_2", label: "SOV Page- 2" },
        { key: "sov_page_3", label: "SOV Page- 3" },
        { key: "sov_page_4", label: "SOV Page- 4" },
        { key: "sov_page_5", label: "SOV Page- 5" },
      ],
      innerTableHeader: [
        { key: "item_count", label: "Product Count" },
        { key: "page_count", label: "Total Product" },
      ],

      viewKeywordData: [],
    };
  },

  mounted() {
    this.dataAPIs();
  },

  methods: {
    dataAPIs() {
      this.formatDates();
      this.getKeywordTableData();
    },
    formatDates() {
      this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
      this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD");
    },
    tableDateChange() {
      this.dataAPIs();
    },
    getKeywordTableData() {
      let self = this;
      self.loader = true;
      self.viewKeywordData = [];
      let payload = {
        start_date: self.dateRange.startDate,
        end_date: self.dateRange.endDate,
      };
      const url = "/api/v2/adword/amazon_brand_search_table_graph";
      self.$http
        .post(url, payload)
        .then((response) => {
          if (Object.keys(response.data.data).length)
            self.viewKeywordData = response.data.data.data;
          self.loader = false;
        })
        .catch((err) => {
          self.loader = false;
          console.log("err");
        });
    },
  },
};
</script>

<style scoped>
#keywordTracker {
    --border: 1px solid var(--base_color-20);
    border-radius: 10px;
    border-spacing: 0;
    border-collapse: separate;
    border: var(--border);
    overflow: hidden;
}

#keywordTracker th:not(:last-child),
#keywordTracker td {
    /* border-right: var(--border) !important; */
}

#keywordTracker>tbody>tr:not(:last-child)>td {
    /* border-bottom: var(--border) !important; */
}

#keywordTracker th {
    background: var(--background);
    padding: 0.6rem !important;
    font-size: 14px !important;
    border-bottom: var(--border) !important;
    font-family: "Poppins", sans-serif !important;
}

/* #keywordTracker td {
    padding: 4px !important;
    font-size: 14px !important;
    font-family: "Heebo", sans-serif !important;
} */
.space-between {
  display: flex;
  justify-content: space-between;
}
thead {
    font-family: "poppins" !important;
    background: var(--background) !important;
    color: #4e4e4e !important;
    font-size: 14px;
    font-weight: bold;
    /* padding: 10px; */
    color: black;
}
tbody {
  font-family: sans-serif;
  font-size: 13px;
}
.pinkColor {
  background: rgb(255 185 185);
  font-weight: bold;
}
.skyColor {
  background: rgb(199 224 255);
  font-weight: bold;
}
.no-data {
  font-size: 16px;
  text-align: center;
  padding: 10px;
  color: red;
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
</style>
